/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-07-18 12:25:48
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-07-29 14:30:53
 */
const operMonitor = () => import("@/views/oper-monitor/alert-notification/alert-notification.vue");
const addAlert = () => import("@/views/oper-monitor/alert-notification/children/add-alert/add-alert.vue");
const upAlert = () => import("@/views/oper-monitor/alert-notification/children/up-alert/up-alert.vue");
const detailsAlert = () => import("@/views/oper-monitor/alert-notification/children/details-alert/details-alert.vue");
const routerList = [
    {
        path: "/oper-monitor/alert-notification",
        name: "警告通知",
        component: operMonitor,
        children: [
            {
                path: "/oper-monitor/alert-notification/add",
                name: "新增策略",
                component: addAlert,
                meta: {
                    nameKey: "addAlert",
                },
            },
            {
                path: "/oper-monitor/alert-notification/updata",
                name: "修改策略",
                component: upAlert,
                meta: {
                    nameKey: "upAlert",
                },
            },
            {
                path: "/oper-monitor/alert-notification/details",
                name: "策略详情",
                component: detailsAlert,
                meta: {
                    nameKey: "detailsAlert",
                },
            },
        ],
    },
    {
        path: "/oper-monitor/startup-fail-order",
        name: "启动失败订单",
        component: () => import("@/views/oper-monitor/startup-fail-order/startup-fail-order.vue"),
    },
    {
        path: "/oper-monitor/overview",
        name: "运维概览",
        component: () => import("@/views/oper-monitor/overview/overview.vue"),
    },
];
export default routerList;
